module.exports = __webpack_public_path__ + "res/ic_edit_t.9dd19b4ff251d3d3418f36c9ddfde546.png";